import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';

const ForbiddenPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleGoBack = () => {
        if (location.state?.from) {
            navigate(-1);
        } else {
            navigate('/');
        }
    };

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className="flex align-items-center justify-content-center min-h-screen">
            <div className="text-center">
                <div className="mb-4">
                    <i className="pi pi-exclamation-triangle text-6xl text-red-500"></i>
                </div>
                <h1 className="text-6xl font-bold text-red-500 mb-3">403</h1>
                <h2 className="text-2xl font-semibold mb-3">Erişim Reddedildi</h2>
                <p className="text-lg text-gray-600 mb-4">
                    Bu sayfaya erişim yetkiniz bulunmamaktadır.
                </p>
                <div className="flex gap-3 justify-content-center">
                    <Button 
                        label="Geri Dön" 
                        icon="pi pi-arrow-left" 
                        onClick={handleGoBack}
                        severity="secondary"
                    />
                    <Button 
                        label="Ana Sayfa" 
                        icon="pi pi-home" 
                        onClick={handleGoHome}
                    />
                </div>
            </div>
        </div>
    );
};

export default ForbiddenPage; 